import React, { VFC } from 'react';
import cn from 'classnames';
import { CloseIcon } from '../../icons';
import styles from './clear-text-button.module.scss';
import text from './clear-text-button.text.json';

type Props = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  hidden: boolean;
};

export const ClearTextButton: VFC<Props> = ({ hidden, onClick }) => {
  return (
    <button
      aria-label={text.CLEAR_TEXT}
      aria-hidden={hidden}
      className={cn(styles.button, hidden && styles.hidden)}
      onClick={onClick}
      data-testid="reset-button"
    >
      <CloseIcon className={styles.icon} />
    </button>
  );
};
